import React, {Component} from 'react';
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Chart from "react-google-charts";
import Autocomplete from "react-autocomplete";
import Utils, {arrayToDataTable} from "../../config/Utils";
import Aux from "react-aux";
import {ChartCardComponent} from "../../v2/components/chartCards/chartCard";
import {Link} from "react-router-dom";
import {MiniCardComponent} from "../../v2/minicard/minicard";
import countries from "../../../assets/country_codes";

class CompanyStatistics extends Component {

    state = {
        companyName: "",
        compareToCompany: "",
        colors: ['red', 'green', 'blue']
    };

    componentDidMount() {
        const queryParams = Utils.decodeQueryString(this.props.location.search);
        let companyName = queryParams['company'];
        if (!companyName) {
            this.props.history.goBack();
        }
        this.props.loadStatistics(companyName);
        this.setState({companyName});
        this.props.fetchCountries(companyName)
        this.props.clearSelection();
    }

    drawAtcCoverageChart = () => {
        let data = arrayToDataTable(this.props.companyStatistics.drugsCountByATC, ['ATC', 'Drugs count']);
        return (
            <ChartCardComponent
                title={`${this.state.companyName} ATC Coverage`}
                subtitle={`Percentage of produced drugs per ATC Group for ${this.state.companyName}`}
                height={'350px'}
                data={data}
                chartType={'PieChart'}
            />
        )
    };

    onInputChange = e => {
        this.setState({compareToCompany: e.target.value});
        if (e.target.value == null || e.target.value.length === 0)
            this.props.clearSelection()
        this.props.searchByName(e.target.value);
    };

    renderItem = (item, isHighlighted) => {
        let displayName = item;
        if (item.length > 35) {
            displayName = item.substr(0, 35) + "...";
        }
        return (
            <button key={item}
                    style={{background: isHighlighted ? 'lightgray' : 'white'}}
                    className={'dropdown-item text-dark w-100'}
            >
                {displayName}
            </button>
        )
    };

    onSelect = val => {
        this.setState({compareToCompany: val});
        this.props.loadStatisticsForOpponent(val);
        this.props.fetchOpponentCountries(val);
    };

    renderCompanyLineChart = () => {
        let data = arrayToDataTable(this.props.companyStatistics.drugsCountPerYear, ['Year', 'Drugs count']);
        return (
            <ChartCardComponent
                title={`${this.state.companyName} line chart`}
                subtitle={`Number of approved drugs per year for ${this.state.companyName}`}
                height={'350px'}
                data={data}
                chartType={'LineChart'}
            />
        )
    };

    prepareData = (isFirstCompany) => {
        let data;
        const companyStatistics = this.props.companyStatistics;
        const companyOpponentStatistics = this.props.companyOpponentStatistics;
        if (!companyOpponentStatistics) return null
        if (isFirstCompany) {
            data = companyStatistics.drugsCountByATC.map(item => [item.countryCode, item.count]);
            data.unshift(['ATC', 'Drugs count']);
        } else {
            let sortableData = [];
            for (const drugData of companyOpponentStatistics.drugsCountByATC) {
                sortableData.push(drugData)
            }
            sortableData.sort((a, b) => {
                return a.countryCode > b.countryCode ? 1 : -1;
            });
            data = arrayToDataTable(sortableData, ['ATC', 'Drugs count']);
        }
        return data

    }

    renderCompanyStatistics = (isFirstCompany) => {
        let data = this.prepareData(isFirstCompany)
        if (!this.props.companyStatistics || !this.props.companyOpponentStatistics) {
            return null;
        }
        let companyStatistics = isFirstCompany ? this.props.companyStatistics : this.props.companyOpponentStatistics;
        return (
            <>
                <div className="row mb-3">
                    <div className="col-4">
                        <MiniCardComponent
                            value={companyStatistics.firstDrugApprovedOn ? companyStatistics.firstDrugApprovedOn : 'Unknown'}
                            text={"First Drug Approved"}
                        />
                    </div>
                    <div className="col-4 pl-0">
                        <MiniCardComponent
                            value={companyStatistics.lastDrugApprovedOn ? companyStatistics.lastDrugApprovedOn : 'Unknown'}
                            text={"Last Drug Approved"}
                        />
                    </div>
                </div>
                <div className='ibox'>
                    <div className="ibox-content">
                        <h3>
                            {isFirstCompany ? this.state.companyName : this.state.compareToCompany}
                        </h3>
                        <h1 className="no-margins">{companyStatistics.totalDrugs}</h1>
                        <small>Total drugs</small>
                        <Chart
                            height={'400px'}
                            chartType="PieChart"
                            loader={
                                <div style={{minHeight: '30vh'}}
                                     className='d-flex align-items-center justify-content-center'>
                                    <CircularProgress/>
                                </div>}
                            data={data}
                            options={{
                                legend: 'left',
                                pieHole: '0.3'
                            }}
                        />
                    </div>
                </div>
            </>
        )
    };

    renderCombinedChart = (isAtcChart) => {
        const companyOpponentStatistics = this.props.companyOpponentStatistics;
        const companyStatistics = this.props.companyStatistics;
        let data;
        if (!companyOpponentStatistics) {
            return null;
        }
        if (isAtcChart) {
            let atcCount = {};
            companyStatistics.drugsCountByATC.forEach(item => {
                atcCount[item.countryCode] = {"home_company": item.count}
            });
            companyOpponentStatistics.drugsCountByATC.forEach(item => {
                if (!atcCount[item.countryCode]) {
                    atcCount[item.countryCode] = {};
                }
                atcCount[item.countryCode]["opponent_company"] = item.count;
            });
            data = [];
            data.push(["ATC Group", companyStatistics.companyName, companyOpponentStatistics.companyName]);
            Object.keys(atcCount).forEach(key => {
                const opponent = atcCount[key]["opponent_company"] || 0;
                const home = atcCount[key]["home_company"] || 0;
                data.push([key, home, opponent]);
            });
        } else {
            let yearlyCount = {};
            companyStatistics.drugsCountPerYear.forEach(item => {
                yearlyCount[item.countryCode] = {"home_company": item.count}
            });
            companyOpponentStatistics.drugsCountPerYear.forEach(item => {
                if (!yearlyCount[item.countryCode]) {
                    yearlyCount[item.countryCode] = {};
                }
                yearlyCount[item.countryCode]["opponent_company"] = item.count;
            });
            data = [["Drugs count", companyStatistics.companyName, companyOpponentStatistics.companyName]];
            let todayYear = new Date().getFullYear();
            for (let i = todayYear - 10; i <= todayYear; i++) {
                let year = i.toString();
                if (!yearlyCount[year]) {
                    yearlyCount[year] = {};
                }
                const opponent = yearlyCount[year]["opponent_company"] || 0;
                const home = yearlyCount[year]["home_company"] || 0;
                data.push([year, home, opponent])
            }
        }

        return (
            <ChartCardComponent
                title={isAtcChart ? 'Total drugs by ATC Group' : 'Total drugs per year'}
                subtitle={'Comparing accumulated data for both companies'}
                data={data}
                chartType={'Bar'}
                height={'450px'}
            />
        )
    };

    render() {
        if (!this.props.companyStatistics) {
            return (
                <div className='d-flex align-items-center justify-content-center' style={{minHeight: '60vh'}}>
                    <CircularProgress/>
                </div>
            )
        }
        return (
            <Aux>
                <div className={'card-header bg-success text-light d-flex justify-content-between align-items-center'}>
                    <div className='d-flex align-items-center justify-content-center'>
                        <h2 className='m-0 font-weight-bold'>{this.state.companyName}</h2>
                        <Link className='btn btn-white btn-outline ml-3 btn-xl font-weight-bold text-uppercase' to={{
                            pathname: '/companies/details/recently-approved',
                            state: {companyName: this.state.companyName}
                        }}>Recently approved drugs?</Link>
                    </div>
                    <div className="col-3 text-dark">
                        <Autocomplete
                            getItemValue={(item) => item}
                            items={this.props.searchResult || []}
                            renderItem={this.renderItem}
                            value={this.state.compareToCompany}
                            onChange={this.onInputChange}
                            onSelect={this.onSelect}
                            inputProps={{className: 'form-control w-100'}}
                            menuStyle={{
                                overflow: 'hidden',
                                width: 100,
                                display: "block",
                                zIndex: 10,
                                position: 'absolute',
                                left: 0,
                                top: '100%'
                            }}
                            wrapperStyle={{display: 'block', position: 'relative'}}
                        />
                    </div>
                </div>

                <div className={'row mt-3'}>
                    <div className={'col-6'}>
                        {this.drawAtcCoverageChart()}
                    </div>
                    <div className={'col-6'}>
                        {this.renderCompanyLineChart()}
                    </div>
                </div>
                <div className="row mt-3 px-3 mb-3">
                    {
                        this.props.companyCountries && this.props.companyOpponentCountries ? (
                            <>
                                <div className="col-6 pl-0">
                                    <div className="d-flex flex-wrap align-items-center">
                                        {
                                            this.props.companyCountries.length > 0
                                                ? this.props.companyCountries
                                                    .filter(it => it != null)
                                                    .map(it =>
                                                        <div className="col-4 pl-0" key={it}>
                                                            <MiniCardComponent
                                                                value={countries[it]}
                                                                text={"Available"}
                                                            />
                                                        </div>
                                                    ) : null
                                        }
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="d-flex flex-wrap align-items-center">
                                        {
                                            this.props.companyOpponentCountries.length > 0
                                                ? this.props.companyOpponentCountries
                                                    .filter(it => it != null)
                                                    .map(it =>
                                                        <div className="col-4 pl-0" key={it}>
                                                            <MiniCardComponent
                                                                value={countries[it]}
                                                                text={"Available"}
                                                            />
                                                        </div>
                                                    ) : null
                                        }
                                    </div>
                                </div>
                            </>
                        ) : null
                    }
                </div>
                <div className="row">
                    <div className='col-6'>
                        {this.renderCompanyStatistics(true)}
                    </div>
                    <div className='col-6'>
                        {this.renderCompanyStatistics(false)}
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        {this.renderCombinedChart(false)}
                    </div>
                    <div className="col-6">
                        {this.renderCombinedChart(true)}
                    </div>
                </div>

            </Aux>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        loadStatistics: (name) => dispatch(actions.getStatisticsForCompany(name)),
        loadStatisticsForOpponent: (name) => dispatch(actions.getStatisticsForCompanyOpponent(name)),
        fetchCountries: (name) => dispatch(actions.getCountriesForCompany(name)),
        fetchOpponentCountries: (name) => dispatch(actions.getCountriesForOpponentCompany(name)),
        searchByName: (name) => dispatch(actions.searchManufacturersByName(name)),
        clearSelection: () => dispatch(actions.clearSelection())
    }
};


const mapStateToProps = state => {
    return {
        companyStatistics: state.drugs.companyStatistics,
        companyOpponentStatistics: state.drugs.companyOpponentStatistics,
        companyCountries: state.company.companyCountries,
        companyOpponentCountries: state.company.companyOpponentCountries,
        searchResult: state.drugs.searchResult,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyStatistics);
